// VITE_BACKEND_BASE_URL already includes the /api/v1 base path, so endpoint
// paths must be relative to it (matching screeningEndpoints / eddEndpoints).
const kybModulePolicyEndpoints = {
  status: () => "/kyb/policy/status",
  policy: () => "/kyb/policy",
};

export default kybModulePolicyEndpoints;
